module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0075.png.8d8c08df.jpg";